import { render, staticRenderFns } from "./TechnicianChangeCognitoButton.vue?vue&type=template&id=63b9c701"
import script from "./TechnicianChangeCognitoButton.vue?vue&type=script&lang=ts"
export * from "./TechnicianChangeCognitoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports